import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatefieldComponent } from '../components/datefield/datefield.component';
import { IonicComponentsModule } from './ionic-components.module';
import { DatetimefieldComponent } from '../components/datetimefield/datetimefield.component';
import { ComboboxWithStoreComponent } from '../components/combobox-with-store/combobox-with-store.component';
import { TimefieldComponent } from '../components/timefield/timefield.component';
import { TextinputComponent } from '../components/textinput/textinput.component';
import { NumericinputComponent } from '../components/numericinput/numericinput.component';
import { NumericintegerinputComponent } from '../components/numericintegerinput/numericintegerinput.component';
import { CheckboxComponent } from '../components/checkbox/checkbox.component';
import { MultiselectWithStoreComponent } from '../components/multiselect-with-store/multiselect-with-store.component';
import { RadiogroupComponent } from '../components/radiogroup/radiogroup.component';
import { TakePhotoComponent } from '../components/take-photo/take-photo.component';
import { DefectosComponent } from '../components/defectos/defectos.component';
import { CanvasDrawingComponent } from '../components/canvas-drawing/canvas-drawing.component';
import { RadiogroupMultiComponent } from '../components/radiogroup-multi/radiogroup-multi.component';
import { FotosComponent } from '../components/fotos/fotos.component';
import { AdjuntosComponent } from '../components/adjuntos/adjuntos.component';
import { PipesModule } from '../pipes/pipes.module';
import { FirmaLocalComponent } from '../components/firma-local/firma-local.component';
import { AppstatusComponent } from '../components/appstatus/appstatus.component';
import { DatefieldSistemaComponent } from '../components/datefield-sistema/datefield-sistema.component';
import { TimefieldSistemaComponent } from '../components/timefield-sistema/timefield-sistema.component';
import { SeleccionAdjuntosDescargarComponent } from '../components/seleccion-adjuntos-descargar/seleccion-adjuntos-descargar.component';

const Modules = [
  CommonModule,
  DatefieldComponent,
  DatetimefieldComponent,
  ComboboxWithStoreComponent,
  TimefieldComponent,
  IonicComponentsModule,
  TextinputComponent,
  NumericinputComponent,
  NumericintegerinputComponent,
  CheckboxComponent,
  MultiselectWithStoreComponent,
  RadiogroupComponent,
  RadiogroupMultiComponent,
  TakePhotoComponent,
  DefectosComponent,
  CanvasDrawingComponent,
  FotosComponent,
  AdjuntosComponent,
  FirmaLocalComponent,
  AppstatusComponent,
  DatefieldSistemaComponent,
  TimefieldSistemaComponent
]

@NgModule({
  declarations: [],
  imports: [
    ...Modules
  ],
  exports: [
    ...Modules
  ]
})
export class ComponentsModule { }
